import Style from "./css/style.module.css";
import ContPartTableArea from "./cont_part";

function GroupDetArea(props: any) {
  let myProps = {
    pre_data: {},
    ...props
  };
  let pre_data = myProps.pre_data;
  let textbook_det_info: any = null;
  if (pre_data["textbook_det_info"]) {
    textbook_det_info = pre_data["textbook_det_info"];
  }

  let cont_part = "word";
  let cont_part_arr = ["word", "stc"];

  let study_sort = "";
  if (textbook_det_info && textbook_det_info["a_par_id"]) {
    study_sort = textbook_det_info["a_par_id"];
  }
  if (study_sort == "") {
    if (pre_data.group_stu_info && pre_data.group_stu_info.a_g_par_id == "word_inside") {
      if (pre_data.group_stu_det_arr
        && pre_data.group_stu_det_arr.length > 0) {
        study_sort = pre_data.group_stu_det_arr[0].a_cont_part;
        if (study_sort == "word") {
          study_sort = "word_study";
        } else {
          study_sort = "word_school";
        }
      }
    }
  }

  if (study_sort == "word_study") {
    cont_part_arr = ["word"];
  } else if (study_sort == "word_school") {
    cont_part_arr = ["stc"];
  }

  const get_cont_part_table_tags = () => {
    let cont_part_table_tags = cont_part_arr.map((item: any, idx: number) => {
      return (
        <ContPartTableArea
          key={idx}
          study_sort={study_sort}
          cont_part={item}
          pre_data={pre_data}
          Style={Style}
        ></ContPartTableArea>
      );
    });
    return cont_part_table_tags;
  };

  return (
    <div className={Style.group_det_wrap}>
      {get_cont_part_table_tags()}
    </div>
  );
};
export default GroupDetArea;